import styles from "./DevStateSwitcher.module.css";

// Development-only control for previewing account states without a backend
export default function DevStateSwitcher({ value, options, onChange, label = "DEV", stacked = false }) {
  return (
    <div
      className={`${styles.switcher} ${stacked ? styles.stacked : ""}`}
      role="group"
      aria-label={`Simulate ${label === "DEV" ? "account" : label.toLowerCase()} state`}
    >
      <span className={styles.label}>{label}</span>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={`${styles.option} ${option === value ? styles.optionActive : ""}`}
          aria-pressed={option === value}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
